import { Injectable, inject } from '@angular/core';
import {SwapShift} from "../../models/swap-shift-model";
import {RoutesResult} from "planner-shared";
import {Observable} from "rxjs";
import {OngoingRequestTrackerService, SessionService} from "@core";
import {HttpClient} from "@angular/common/http";

@Injectable({
    providedIn: 'root'
})
export class SwapShiftService {
    private readonly sessionService = inject(SessionService);
    private readonly httpClient = inject(HttpClient);
    private readonly ongoingRequestTracker = inject(OngoingRequestTrackerService);


    public swapShift(swapShift: SwapShift): Observable<RoutesResult> {
        const url = `${this.sessionService.getApiUrl()}/swap_shift/${this.sessionService.getJobId()}`;
        const body = {
            swapWorkShifts: swapShift,
        };
        const requestOptions = this.ongoingRequestTracker.createTrackingEnabledRequestOptions();

        return this.httpClient.put<RoutesResult>(url, body, requestOptions);
    }

}
